import { type RoleAssignment } from '@gb-ticket/shared-types';

import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { visibleRoleBadges } from '@/platform/features/users/visible-role-badges';

export function RoleAssignmentBadges({
  roles,
  compact = false,
}: {
  roles: RoleAssignment[];
  /** Engere Darstellung in Tabellen (ein Badge + „+N“). */
  compact?: boolean;
}) {
  const { shown, restNames } = visibleRoleBadges(roles, compact ? 1 : 2);
  if (shown.length === 0) {
    return null;
  }
  const badgeClass = compact
    ? 'max-w-full truncate px-1.5 py-0 text-[10px] font-normal'
    : undefined;
  return (
    <div className={cn('flex gap-0.5', compact ? 'min-w-0 flex-nowrap' : 'flex-wrap gap-1')}>
      {shown.map((role) => (
        <Badge
          key={role.code}
          variant={role.isSystem ? 'secondary' : 'outline'}
          className={badgeClass}
          title={role.name}
        >
          {role.name}
        </Badge>
      ))}
      {restNames.length > 0 ? (
        <Badge variant="outline" className={badgeClass} title={restNames.join(', ')}>
          +{restNames.length}
        </Badge>
      ) : null}
    </div>
  );
}
